import { createContext, Dispatch, SetStateAction } from "react";
import { Thread } from "@/features/chat/types/sdk";

interface ThreadFetchOptions {
  limit?: number;
  metadata?: Record<string, unknown>;
}

interface ThreadContextType {
  getThreads: (options?: ThreadFetchOptions) => Promise<Thread[]>;
  threads: Thread[];
  setThreads: Dispatch<SetStateAction<Thread[]>>;
  threadsLoading: boolean;
  setThreadsLoading: Dispatch<SetStateAction<boolean>>;
}

export const ThreadContext = createContext<ThreadContextType | undefined>(undefined);
